module.exports = __webpack_public_path__ + "img/difangzhi.9d449da0.png";